import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../../component/BreadCrumbBanner";
import facilitiesAPI from "../../api/facilitiesApi";

const SmartClassroom = () => {
  const [smartClassroomData, setSmartClassroomData] = useState(null);

  useEffect(() => {
    fetchSmartClassroomData();
  }, []);

  const fetchSmartClassroomData = async () => {
    const res = await facilitiesAPI.smart_classroom();

    if (res.code === 200) {
      const result = res.data;
      setSmartClassroomData(result);
    }
  };
  const smartData = smartClassroomData?.["smart-classroom"]?.[0];

  return (
    <>
      {/* BreadCrump Section */}
      <BreadCrumbBanner
        title="Smart Classrooms"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {/* Technology in Education */}

      {smartClassroomData && (
        <>
          <section className="smart-technology-section pt-5 bg-light">
            <div className="container">
              <div className="row justify-content-center text-center">
                <div className="col-lg-12">
                  <h2 className="mrv-title">{smartData?.maintitle}</h2>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: smartData?.shortdescription || "",
                    }}
                  />
                </div>
              </div>
            </div>
          </section>

          <section className="smart-classroom-unique bg-light">
            <div className="container">
              <div className="row align-items-stretch g-0">
                {/* LEFT CONTENT */}
                <div className="col-lg-5 order-2 order-lg-1 d-flex flex-column justify-content-center animate__animated animate__fadeIn">
                  <div className="content-wrapper py-4">
                    <div className="header-group">
                      <span className="mrv-subtitle mb-1">
                        {smartData?.subtitle}
                      </span>
                      <h2 className="mrv-title text-primary-mrv">
                        {smartData?.title}
                      </h2>
                      <div
                        className="description-text"
                        dangerouslySetInnerHTML={{
                          __html: smartData?.description || "",
                        }}
                      />
                    </div>
                    {/* FEATURES */}
                    <div className="feature-stack mt-4">
                      {smartData?.listings?.map((item, index) => (
                        <div key={index} className="stack-item">
                          <div className="stack-icon">
                            <img src={item?.icon} className="library-icon" loading="lazy" />
                          </div>

                          <div className="stack-text">
                            <h6>{item.listingtitle}</h6>

                            <div
                              dangerouslySetInnerHTML={{
                                __html: item.listingdescription || "",
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/* RIGHT IMAGE */}
                <div className="col-lg-7 order-1 order-lg-2 mb-4 mb-lg-0">
                  <div className="image-composite-wrapper h-100">
                    <div className="main-image-frame h-100 animate__animated animate__zoomIn">
                      <img
                        src={smartData?.image}
                        alt="Classroom"
                        className="img-fluid main-img h-100 w-100"
                        loading="lazy"
                        style={{ objectFit: "cover" }}
                      />
                      {/* FLOATING CARD */}
                      <div className="floating-info-card card-bottom animate__animated animate__bounceInUp">
                        <i className="bi bi-brightness-high-fill" />
                        <span>Optimized Lighting</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default SmartClassroom;
